var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exportStateCell"},[_c('div',{staticClass:"flex flex-align-center"},[(_vm.row[_vm.column.key])?_c('div',{class:['state_icon', _vm.row.export_status == '1' ? 'success' : 'danger']}):_c('i',{staticClass:"el-icon-loading loading"}),_c('p',{staticClass:"ml-6"},[_vm._v(_vm._s(_vm.row['export_status_desc']))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }